import React, {useEffect} from 'react';
import './Menu.css';
import MenuItem from "./MenuItem/MenuItem";
import logoWhite from '../../../Assets/logowhite.svg';
import defaultLogo from '../../../Assets/logodefault.svg';
import {Link} from "react-router-dom";

const Menu = props => {

    useEffect(()=>{
        document.addEventListener("scroll", function(){
            let scroll = document.scrollingElement.scrollTop;
            let navBar = document.getElementById("menu");
            let menuButton = document.getElementById("menu-trail-button");
            let logo = document.getElementById("menu-logo");
            let hamburger = document.getElementById("menu-hamburger");
            if(scroll>100){
                navBar.classList.add("menu-white");
                navBar.classList.remove("menu-transparent");
                menuButton.classList.remove("adg-btn-white-transparent");
                logo.src = defaultLogo;
                hamburger.classList.remove("hamburger-tile-white");
                navBar.classList.add("hamburger-tile-default");
            }
            else{
                navBar.classList.add("menu-transparent");
                navBar.classList.remove("menu-white");
                menuButton.classList.add("adg-btn-white-transparent");
                logo.src = logoWhite;
                hamburger.classList.add("hamburger-tile-white");
                navBar.classList.remove("hamburger-tile-default");
            }
        })
    });

    const menuData = {
        "sevices": {
            "items":[
                {"label":"Finance & Accounting", "serviceKey":"finAcc", "desc":"Reliable and Up-to-date, accounting services with its collaborative, customized engagement approach."},
                {"label":"Business Support Services", "serviceKey":"businessSuppServices", "desc":"Audigo will build successful solutions to fit your needs. Whether you are a global conglomerate or a closely held business"},
                {"label":"Due Diligence & Legal Advisory", "serviceKey":"dueDiligence", "desc":"Due diligence to guide critical decisions on Mergers, acquisitions and financial investments, involve high-stake decisions."},
                {"label":"Tax Advisory", "serviceKey":"taxAdvisory", "desc":"Obtaining the best advice when you need it can save a lot of time and money – not to mention, stress"},
                {"label":"People Management", "serviceKey":"peopleManagememt", "desc":"Audigo offer tailored recruitment, payroll management and hiring solutions, supporting your global expansion"},
                {"label":"Software Services", "desc":"Provides softwares using cutting edge technologies and user friendly interfaces to enrich your business"},
            ],
            "label":"Services"
        },
        "resourses":{
            "label":"Resourses"
        }
    };
    const logo = (
        <img src={logoWhite} alt="audigo_logo" id="menu-logo"/>
    );

    return (
        <div id="menu">
            <div id="menu-hamburger" className="hamburger-tile-white">
                {/*<span className="menu-hamburger-tile"/>*/}
                {/*<span className="menu-hamburger-tile"/>*/}
                {/*<span className="menu-hamburger-tile"/>*/}
            </div>
            <div className="menu-items">
                <MenuItem subMenuItems={menuData.sevices.items} label={menuData.sevices.label} changeService={props.changeService}/>
                {/*<MenuItem subMenuItems={menuData.resourses.items} label={menuData.resourses.label}/>*/}
            </div>
            <div id="menu-brand" onClick={()=>props.returnToHome()}>
                <span id="logo-label">
                    Audigo
                </span>{logo}
            </div>
            <div className="menu-items" style={{'justify-content':'flex-end'}}>
                {/*<MenuItem label="Client Login" />*/}
                <a href="https://forms.gle/2itxQL3W6DPE8Sxp8" target="_blank">
                    <div id="menu-trail-button" className="adg-btn adg-btn-hightlight">Start a Free Trail</div>
                </a>
                </div>
        </div>
    );
};

export default Menu;


// WEBPACK FOOTER //
// ./src/Components/LandingPage/Menu/Menu.js